// Universal Analytics (UA-202414358-1) was shut down by Google in July 2023.
// The event-tracking calls below are kept in code but routed to this no-op sink
// instead of the `react-ga` instance, so they no longer hit a dead endpoint.
type GaEvent = { category?: string; action?: string; label?: string; value?: number };

export const ReactGA = {
  initialize: (_trackingID: string): void => {},
  event: (_event: GaEvent): void => {},
  set: (_fields: Record<string, unknown>): void => {},
};

export const trackingId = 'UA-202414358-1';

export const dataGA = (status, licensesPaid) => {
  const selectedStatus = status === 'success' ? 'successful' : 'canceled';
  const firstPurchase = licensesPaid === 0 ? '_first' : '';

  return [
    {
      label: 'TigerX1',
      category: 'REVENUE',
      action: `purchase_${selectedStatus}_x1${firstPurchase}`,
      value: 49,
    },
    {
      label: 'TigerX3',
      category: 'REVENUE',
      action: `purchase_${selectedStatus}_x3${firstPurchase}`,
      value: 124,
    },
    {
      label: 'TigerX6',
      category: 'REVENUE',
      action: `purchase_${selectedStatus}_x6${firstPurchase}`,
      value: 224,
    },
    {
      label: 'TigerX12',
      category: 'REVENUE',
      action: `purchase_${selectedStatus}_x12${firstPurchase}`,
      value: 399,
    },
    {
      label: 'Player',
      category: 'REVENUE',
      action: `purchase_${selectedStatus}_player${firstPurchase}`,
      value: 15,
    },
  ];
};

export const initGA = (trackingID) => {
  ReactGA.initialize(trackingID);
};

export const eventAnalytics = ({ category, action, label, value }: AnalyticsEvent) => {
  ReactGA.event({
    category,
    action,
    label,
    value,
  });
};
